const ar = {
  nav: {
    home: "الرئيسية",
    services: "الخدمات",
    blog: "المدونة",
    about: "من نحن",
    contact: "تواصل معنا",
  },
  hero: {
    title: "تعليم طفلك في مصر\nمن البداية إلى النهاية",
    subtitle: "من اختيار المدرسة واستكمال الإجراءات إلى الإقامة والسكن، نتولى كل خطوة نيابةً عنك، برفقة فريق يدعمك في كل خطوة",
    cta: "احجز استشارة مجانية",
  },
  homeIntro: {
    titlePrefix: "أكثر من",
    titleHighlight: "10 سنوات",
    description: "تأسست EduVate لتسهيل رحلة الدراسة في مصر للعائلات القادمة من الأردن والسودان واليمن ومختلف الدول العربية. نمتلك خبرة عميقة بالمدارس، والأنظمة، والإجراءات، وندرك تمامًا ما يشغل بال أولياء الأمور. مهمتنا هي أن نخفف عنك هذا العبء بالكامل.\n\nمن أول تواصل معنا وحتى أول يوم دراسي، نكون معك في كل خطوة.",
    cta: "تعرف علينا أكثر",
  },
  homeStats: {
    items: [
      { labelBefore: "أكثر من", valueFirst: "10 سنوات", labelAfter: "من الخبرة" },
      { labelBefore: "أكثر من", valueFirst: "1000 طالب", labelAfter: "تم تسجيلهم" },
      { labelBefore: "أكثر من", valueFirst: "20 شريكًا", labelAfter: "تعليميًا" },
      { labelBefore: "طلاب من", valueFirst: "أكثر من 20 دولة" },
    ],
  },
  homeServices: {
    title: "كل ما تحتاجه في مكان واحد",
    description: "نتولى الرحلة بالكامل، من اختيار المسار التعليمي المناسب وحتى أول أسبوع دراسي.",
    cta: "استعرض جميع الخدمات",
    items: [
      {
        title: "اختيار المدرسة والاستشارة الأكاديمية",
        description: "نساعدك في اختيار المدرسة والنظام المناسب وفقًا لمستوى الطالب وأهداف الأسرة.",
      },
      {
        title: "التقديم والإجراءات",
        description: "نتولى تجهيز جميع الأوراق والتقديم والمتابعة مع الجهات التعليمية حتى صدور القبول.",
      },
      {
        title: "إدارة الإقامة",
        description: "نرشدك خلال خطوات الإقامة في مصر، بما يشمل المستندات المطلوبة وتوقيت الإجراءات.",
      },
      {
        title: "السكن والمواصلات",
        description: "نساعد في توفير سكن مناسب بالقرب من المدرسة وتنظيم الحياة اليومية للطالب.",
      },
      {
        title: "دعم مستمر للطالب",
        description: "يستمر دعمنا حتى بعد القبول، ونبقى على تواصل مع الطلاب وأولياء الأمور طوال العام الدراسي.",
      },
    ],
  },
  homeWhyEgypt: {
    title: "لماذا مصر؟",
    description: "تُعد مصر من أبرز الوجهات التعليمية في العالم العربي، وذلك لعدة أسباب.",
    cta: "استعرض جميع الخدمات",
    items: [
      {
        icon: "curriculum",
        title: "أنظمة تعليمية معترف بها",
        description: "تقدم المدارس في مصر ثلاثة مسارات رئيسية: النظام الوطني، والنظام البريطاني IG، والدبلومة الأمريكية، وجميعها معترف بها محليًا ودوليًا.",
      },
      {
        icon: "home",
        title: "قرب المسافة",
        description: "تقع مصر على مسافة قريبة من معظم الدول العربية، مما يسهل زيارة العائلات ويخفف شعور الغربة لدى الطلاب.",
      },
      {
        icon: "arabic",
        title: "بيئة عربية مألوفة",
        description: "توفر مصر بيئة لغوية وثقافية قريبة من الطالب العربي، مما يجعل عملية التأقلم أكثر سهولة مقارنة بالدول الأجنبية.",
      },
      {
        icon: "affordable",
        title: "جودة بتكلفة مناسبة",
        description: "توفر مصر تعليمًا عالي الجودة بتكلفة أقل.",
      },
      {
        icon: "support",
        title: "أمان ودعم مستمر",
        description: "معنا لا يكون الطالب بمفرده. نوفر الدعم في السكن والمواصلات وكل التفاصيل اليومية، لتشعر الأسرة بالاطمئنان.",
      },
    ],
  },
  homeCurriculumPaths: {
    titleHighlight: "ثلاثة",
    title: "مسارات تعليمية ونساعدك في اختيار الأنسب",
    footerText: "لست متأكدًا من الخيار الأنسب؟ مستشارونا جاهزون لمساعدتك.",
    cta: "احصل على استشارة مجانية",
    items: [
      {
        title: "النظام الوطني",
        description:
          "مناسب للطلاب الراغبين في الاندماج الكامل داخل النظام التعليمي المصري.",
        image: "/images/curriculum-national.png",
        imagePosition: "center center",
      },
      {
        title: "النظام البريطاني IG",
        description:
          "من أكثر الأنظمة انتشارًا عالميًا، يدرس فيه الطالب 8 مواد خلال سنتين أو ثلاث، مع إمكانية إعادة الامتحانات لتحسين الدرجات.",
        image: "/images/curriculum-british.png",
        imagePosition: "center center",
      },
      {
        title: "الدبلومة الأمريكية",
        description:
          "نظام يعتمد على الساعات المعتمدة ويمنح الطالب مرونة في التقدم، وهو معترف به عالميًا.",
        image: "/images/curriculum-american.png",
        imagePosition: "center center",
      },
    ],
  },
  featuredCourses: {
    title: "الدورات المميزة",
    enroll: "سجّل الآن",
    by: "بواسطة",
  },
  homeSupportIntro: {
    title: "قرار بهذا الحجم يحتاج\nإلى دعم حقيقي",
    description:
      "إرسال طفلك للدراسة في بلد جديد ليس قرارًا بسيطًا. يتطلب تخطيطًا وثقة كبيرة. أسسنا EduVate انطلاقًا من فهمنا للتحديات التي تصاحب هذه الرحلة دون دعم.",
  },
  homeCtaBanner: {
    title: "التعليم في أيدٍ أمينة",
    description:
      "إرشاد صحيح يساعد الطلاب على اختيار المسار المناسب وبناء مستقبلهم بثقة.",
    primaryCta: "تواصل معنا",
    secondaryCta: "تعرف علينا",
    image: "/images/quilia-1-aA2Fadydc-unsplash.jpg",
  },
  whyUs: {
    title: "لماذا تختار Eduvate؟",
    items: [
      { title: "مدربون خبراء", description: "تعلّم من محترفين في المجال لديهم خبرة عملية." },
      { title: "تعلّم مرن", description: "ادرس بالسرعة التي تناسبك، في أي وقت ومن أي مكان." },
      { title: "أسعار معقولة", description: "تعليم عالي الجودة يناسب ميزانيتك." },
      { title: "وصول مدى الحياة", description: "الوصول إلى مواد الدورة للأبد." },
    ],
  },
  services: {
    title: "التفاصيل",
    subtitle: "نقدم كل ما تحتاجه الأسرة لبدء تعليم أبنائها في مصر، من أول خطوة حتى التخرج.",
    cta: "استعرض خدماتنا",
    items: [
      {
        title: "مستشار EduVate",
        description:
          "نساعدك على فهم الخيارات المتاحة وفقًا لمستوى الطالب ونرشدك إلى المسار الأنسب.",
      },
      {
        title: "خبير EduVate",
        description:
          "نبحث عن المدارس والبرامج المناسبة بدلًا من التقديم العشوائي.",
      },
      {
        title: "إدارة التقديم",
        description:
          "نتولى جميع الإجراءات والمتابعة حتى استلام خطاب القبول الرسمي.",
      },
      {
        title: "إدارة الإقامة",
        description:
          "نُسهل جميع خطوات الإقامة بالتعاون مع شركاء متخصصين.",
      },
      {
        title: "السكن والمواصلات",
        description:
          "نوفر بيئة مستقرة وآمنة للطالب منذ اليوم الأول.",
      },
      {
        title: "دعم الطالب",
        description:
          "نظل متاحين طوال العام لأي استفسار أو مساعدة.",
      },
    ],
  },
  servicesHero: {
    title: "رحلة الدراسة بالكامل\nنرافقك فيها خطوة بخطوة",
    subtitle:
      "نقدم كل ما تحتاجه الأسرة لبدء تعليم أبنائها في مصر، من أول خطوة حتى التخرج.",
    image: "/images/services-hero-students.png",
  },
  servicesWhy: {
    title: "لماذا EduVate؟",
    description:
      "نؤمن أن كل طالب يستحق فرصة تعليم متميزة، وأن كل أسرة تستحق أن تتخذ قرارها بثقة واطمئنان.\n\nلا نندفع لاتخاذ قرارات سريعة، بل نحرص على فهم كل حالة بعناية، ونستمر في دعمنا حتى بعد القبول. نتعامل مع كل طالب بنفس الاهتمام الذي نتمناه لأبنائنا.",
    image: "/images/support-intro-graduate.jpg",
  },
  servicesFaq: {
    title: "أسئلة شائعة من أولياء الأمور والطلاب.",
    description:
      "قبل بدء الإجراءات، من الطبيعي أن تكون لديكم الكثير من الأسئلة. هذه هي الأسئلة التي نتلقاها أكثر من غيرها مع إجابات واضحة من فريق القبول لدينا.",
    items: [
      {
        question: "ما المستندات المطلوبة للتقديم؟",
        answer:
          "تشمل المستندات المطلوبة: شهادة ميلاد موثقة من السفارة ووزارة الخارجية في بلد الطالب، عدد 8 صور شخصية مكتوب أسفل كل صورة الاسم الكامل للطالب باللغة العربية، هوية سارية لكل من الطالب وولي الأمر، مستندات الإقامة للطالب وولي الأمر، ختم دخول على جواز سفر الطالب، وآخر 3 شهادات دراسية موثقة.\n\nقد تطلب بعض المدارس أيضًا اختبار تحديد مستوى أو مقابلة.",
      },
      {
        question: "هل يجب أن يحضر الطالب إلى مصر شخصيًا؟",
        answer:
          "نعم. يجب حضور الطالب وولي الأمر المرافق إلى مصر لاستكمال إجراءات الإقامة وختم الجواز لدى الجهة المختصة. وإذا تعذر سفر الأب، فيلزم وجود وصاية تعليمية رسمية أو توكيل قانوني لولي أمر بديل.",
      },
      {
        question: "كم تستغرق العملية كاملة بعد وصول الطالب؟",
        answer:
          "في المتوسط تستغرق العملية حوالي أسبوعين، بشرط أن تكون جميع المستندات كاملة وموثقة بشكل صحيح قبل الوصول.",
      },
      {
        question: "هل يمكن لـ EduVate المساعدة في ترتيب السكن خلال الإجراءات؟",
        answer:
          "تعتمد خيارات السكن على وضع الطالب وميزانيته. نحن نساعد العائلات في تحديد الخيارات المناسبة والقريبة من المدرسة.",
      },
      {
        question: "هل الدراسة أونلاين أم حضوريًا؟",
        answer:
          "الخياران متاحان.\n\nأونلاين (Home School): تكلفة أقل، ويدرس الطالب عن بُعد دون الحاجة إلى الحضور اليومي للمدرسة.\n\nحضوري (In-Person): يحضر الطالب إلى المدرسة ويؤدي الامتحانات بشكل مباشر. هذا الخيار أعلى تكلفة لأنه يتطلب سكنًا ومواصلات، لكنه يوفر تجربة مدرسية أكمل.",
      },
      {
        question: "ماذا يحدث بعد تسليم المستندات؟",
        answer:
          "بمجرد استلامنا للمستندات كاملة وموثقة، نبدأ الخطوات التالية:\n\nالتواصل مع المدرسة التي سيتم تسجيل الطالب بها وفقًا لمحل السكن.\nمراجعة الإدارة التعليمية المصرية للحصول على الموافقة الرسمية والختم المؤسسي المطلوب.\nتسجيل الطالب إلكترونيًا في المدرسة، مع مراعاة أن القبول يعتمد على الطاقة الاستيعابية والمرحلة الدراسية.\nبالنسبة للطلاب القادمين من دولة أخرى، يجب تنفيذ معادلة المناهج من خلال الإدارة التعليمية.",
      },
      {
        question: "هل يمكنني اختيار مدرسة أو منطقة محددة؟",
        answer:
          "لا نستطيع ضمان مدرسة محددة بشكل مسبق، لأن التسكين يعتمد على الطاقة الاستيعابية للمدرسة وتوفر الأماكن في الصف المطلوب. بعد تقييم الخيارات وفقًا لهذه العوامل، سنبلغكم بالاختيارات المتاحة ونرشح الأنسب.",
      },
      {
        question: "ما المناهج المتاحة؟",
        answer:
          "يمكن للطلاب الاختيار بين:\n\nالنظام الوطني - المسار العربي أو مسار اللغات.\nالنظام البريطاني IG - يدرس الطالب 8 مواد ويمكنه أداء الامتحانات خلال سنتين إلى 3 سنوات. النظام معترف به بالكامل في مصر من الصف الأول حتى الصف الثاني عشر.\nالدبلومة الأمريكية - نظام يعتمد على الساعات المعتمدة ومعترف به في مصر ودوليًا. يمكن للطالب إنهاء البرنامج مبكرًا إذا أكمل الساعات المطلوبة قبل الموعد المعتاد.\nالبكالوريا الدولية IB - الخيار الأكثر صعوبة من الناحية الأكاديمية، ويعادل الدبلومة الأمريكية من حيث القبول الجامعي.",
      },
      {
        question: "ما أفضل وقت لبدء التقديم؟",
        answer:
          "ننصح ببدء الإجراءات بين يوليو ونوفمبر. أماكن المدارس تمتلئ مبكرًا، والبدء في وقت مبكر يمنح طفلك خيارات أكثر.",
      },
      {
        question: "هل يمكننا التقديم من خارج مصر؟",
        answer:
          "نعم. نحن ندير كامل عملية التقديم والتواصل عن بُعد. لا حاجة للسفر إلا عند وقت استكمال الإقامة بشكل نهائي.",
      },
    ],
  },
  blog: {
    title: "المدونة",
    subtitle: "رؤى ونصائح وقصص من عالم التعليم.",
    readMore: "اقرأ المزيد",
    posts: [
      { title: "١٠ نصائح للتعلم الفعّال عبر الإنترنت", date: "١٥ أبريل ٢٠٢٦", excerpt: "اكتشف استراتيجيات مثبتة لتحقيق أقصى استفادة من تجربة التعليم عبر الإنترنت." },
      { title: "مستقبل تكنولوجيا التعليم في ٢٠٢٦", date: "١٠ أبريل ٢٠٢٦", excerpt: "استكشاف أحدث الاتجاهات والتقنيات التي تشكل صناعة التعليم." },
      { title: "كيف تحافظ على حماسك أثناء الدراسة", date: "٥ أبريل ٢٠٢٦", excerpt: "نصائح عملية للحفاظ على مستوى عالٍ من التحفيز طوال رحلة التعلم." },
      { title: "بناء مسيرة مهنية في التكنولوجيا", date: "٢٨ مارس ٢٠٢٦", excerpt: "دليل شامل لبدء مسيرتك المهنية في قطاع التكنولوجيا." },
    ],
  },
  about: {
    title: "عن Eduvate",
    mission: {
      title: "مهمتنا",
      p1: "في Eduvate، نؤمن بأن التعليم يجب أن يكون متاحاً للجميع في كل مكان. نحن ملتزمون بتقديم دورات عالية الجودة وبأسعار معقولة تساعد المتعلمين على تحقيق أهدافهم.",
      p2: "تجمع منصتنا بين المدربين الخبراء والمتعلمين المتحمسين لإنشاء مجتمع مزدهر من المتعلمين مدى الحياة.",
    },
    whyUs: {
      title: "لماذا تختارنا؟",
      items: [
        "مدربون خبراء ذوو خبرة عملية",
        "جداول تعلم مرنة",
        "أسعار معقولة",
        "وصول مدى الحياة لمواد الدورة",
      ],
    },
    stats: {
      students: "طالب",
      courses: "دورة",
      instructors: "مدرب",
      countries: "دولة",
    },
  },
  aboutHero: {
    title: "نقطة انطلاقك نحو مستقبل تعليمي متميز",
    subtitle:
      "أكثر من 10 سنوات من الخبرة في مساعدة الطلاب العرب على بناء مستقبلهم في مصر.\nقمنا بتوجيه آلاف الطلاب في رحلتهم التعليمية، وما زلنا مستمرين.",
    image: "/images/about-hero-classroom.png",
  },
  aboutVisionMission: {
    image: "/images/support-intro-graduate.jpg",
    visionTitle: "الرؤية",
    visionParagraphs: [
      "أن نكون الشريك الموثوق الذي يربط الطلاب العرب بفرص تعليمية متميزة في مصر.",
    ],
    missionTitle: "الرسالة",
    missionParagraphs: [
      "نرافق الطلاب في كل خطوة من رحلتهم التعليمية، من اختيار المدرسة وحتى بداية الدراسة، ونستمر في دعمهم طوال العام.",
    ],
  },
  contact: {
    title: "نحن هنا لمساعدتك",
    introTitle: "نحن هنا لمساعدتك",
    introDescription:
      "هل لديك سؤال أو تحتاج إلى دعم؟ يمكنك التواصل معنا مباشرة أو تعبئة النموذج. الاستشارة الأولى مجانية.",
    cardTitle: "بيانات التواصل",
    followUs: "تابعنا",
    formLeadTitle: "أخبرنا عن طفلك.",
    formLeadSubtitle:
      "املأ النموذج أدناه وسيتواصل معك أحد مستشارينا في أقرب وقت ممكن.",
    form: {
      name: "الاسم",
      namePlaceholder: "اسمك",
      email: "البريد الإلكتروني",
      emailPlaceholder: "بريدك الإلكتروني",
      message: "الرسالة",
      messagePlaceholder: "رسالتك",
      send: "إرسال الرسالة",
      sending: "جاري الإرسال...",
      success: "شكراً لك! تم إرسال رسالتك بنجاح.",
      error: "حدث خطأ ما. يرجى التحقق من اتصالك والمحاولة مرة أخرى.",
    },
    formFields: {
      studentName: "اسم الطالب",
      studentNamePlaceholder: "اكتب اسم الطالب",
      email: "البريد الإلكتروني",
      emailPlaceholder: "اكتب بريدك الإلكتروني",
      gender: "النوع",
      birthDate: "تاريخ الميلاد",
      phoneNumber: "رقم الهاتف",
      phoneNumberPlaceholder: "00 000 0000",
      school: "المدرسة",
      schoolPlaceholder: "اكتب اسم المدرسة",
      grade: "الصف الدراسي",
      gradePlaceholder: "اكتب الصف الدراسي",
      city: "المدينة",
      cityPlaceholder: "اكتب المدينة",
      studentCategory: "فئة الطالب",
      egyptian: "مصري",
      international: "دولي",
      nonEgyptian: "غير مصري",
      educationSystem: "النظام التعليمي",
      educationSystemPlaceholder: "اكتب النظام التعليمي",
      firstLanguage: "اللغة الأولى",
      firstLanguagePlaceholder: "اكتب اللغة الأولى",
      secondLanguage: "اللغة الثانية",
      secondLanguagePlaceholder: "اكتب اللغة الثانية",
      lastGrade: "آخر تقدير",
      lastGradePlaceholder: "اكتب آخر تقدير",
      selectPlaceholder: "اختر",
      male: "ذكر",
      female: "أنثى",
      newStudent: "طالب جديد",
      transferStudent: "طالب محول",
      nationalSystem: "النظام الوطني",
      britishSystem: "النظام البريطاني IG",
      americanSystem: "الدبلومة الأمريكية",
      ibSystem: "البكالوريا الدولية IB",
      arabic: "العربية",
      english: "الإنجليزية",
      french: "الفرنسية",
      submit: "أرسل بياناتي",
    },
    info: {
      email: "البريد الإلكتروني",
      emailValue: "info@cvis.com.eg",
      phone: "الهاتف",
      phoneValue: "01240079406\n01240079407",
      address: "العنوان",
      addressValue: "129 شارع التحرير، الدقي، الجيزة",
      officeHours: "مواعيد العمل",
      officeHoursValue: "من الأحد إلى الخميس، من 8:00 صباحًا إلى 4:00 مساءً",
    },
  },
  footer: {
    company: "الشركة",
    about: "عن Eduvate",
    aboutText: "نقدم تعليماً عالي الجودة للجميع في كل مكان.",
    quickLinks: "روابط سريعة",
    contactTitle: "تواصل معنا",
    rights: "Eduvate. جميع الحقوق محفوظة.",
    rightsFull: "© 2022 Welcome. جميع الحقوق محفوظة.",
    privacy: "سياسة الخصوصية",
    terms: "شروط الخدمة",
  },
};

export default ar;
